var map = {
	"./huawei/1.png": "4250",
	"./huawei/2.png": "eef9",
	"./huawei/3.png": "529a",
	"./huawei/4.png": "71e8",
	"./huawei/5.png": "3108",
	"./oppo/1.png": "4b49",
	"./oppo/2.png": "57fd",
	"./oppo/3.png": "7f6f",
	"./oppo/4.png": "8ded",
	"./oppo/5.png": "596a",
	"./oppo/6.png": "384f",
	"./vivo/1.png": "c649",
	"./vivo/2.png": "0076",
	"./vivo/3.png": "ada2",
	"./vivo/4.png": "3ee4",
	"./vivo/5.png": "e499",
	"./vivo/6.png": "9f7f",
	"./xiaomi/1.png": "b860",
	"./xiaomi/2.png": "693d",
	"./xiaomi/3.png": "15c9",
	"./xiaomi/4.png": "9045",
	"./xiaomi/5.png": "f36b",
	"./xiaomi/6.png": "3b79"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "69fd";